import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=57b87350&scoped=true&"
import script from "./Order.vue?vue&type=script&lang=js&"
export * from "./Order.vue?vue&type=script&lang=js&"
import style0 from "./Order.vue?vue&type=style&index=0&id=57b87350&prod&lang=css&"
import style1 from "./Order.vue?vue&type=style&index=1&id=57b87350&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../translate-spring/user-center/person-center/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b87350",
  null
  
)

export default component.exports